<template>
  <div>
    <component
      :is="singleCategory ? 'a': 'div'"
      :class="{
        'is-opened': isOpened && !singleCategory,
        'facet-tag-menu__title': !singleCategory
      }"
      :href="singleCategory ? singleCategory.url : null"
      class="relative py-4 cursor-pointer flex items-center font-normal text-sm text-blue-dark"
      @click="singleCategory ? onChangeCategory(singleCategory, $event) : toggleOpen()"
    >
      <span
        class="relative bg-blue-grey rounded ltr:mr-4 rtl:ml-4"
      >
        <img
          v-if="model.image && !singleCategory"
          :src="model.image"
          :alt="model.altText"
          width="40"
          height="40"
        >
        <img
          v-else-if="singleCategory && singleCategory.image"
          :src="singleCategory.image"
          :alt="singleCategory.altText"
          width="40"
          height="40"
        >
        <span
          v-if="singleCategory && checkActive(singleCategory.uid)"
          class="absolute left-0 top-0 w-full rounded h-full bg-blue-light bg-opacity-50 flex justify-center items-center text-white"
        >
          <span class="icon-check text-lg" />
        </span>
      </span>
      {{ singleCategory ? singleCategory.name : model.name }}
      <span
        v-if="total > 0 && !singleCategory"
        class="ltr:ml-2 rtl:mr-2"
      >
        ({{ total }})
      </span>
    </component>
    <div
      v-if="!singleCategory"
      class="facet-tag-menu__accordion-content grid grid-cols-3 gap-6 mt-4 mb-8"
      :class="{ 'is-opened': isOpened }"
    >
      <a
        v-for="category in model.items"
        :key="category.uid"
        :href="category.url"
        class="filter-category flex flex-col justify-items-center gap-16px text-2xs text-center"
        @click="onChangeCategory(category, $event)"
      >
        <span
          class="relative bg-blue-grey aspect-square overflow-hidden rounded p-4"
        >
          <img
            :src="category.image || placeholderImage"
            :alt="category.altText"
            loading="lazy"
            class="w-full h-full"
            width="64"
            height="64"
          >
          <span
            v-if="checkActive(category.uid)"
            class="absolute left-0 top-0 w-full rounded h-full bg-blue-light bg-opacity-50 flex justify-center items-center text-white"
          >
            <span class="icon-check text-6xl" />
          </span>
        </span>
        {{ category.name }}
      </a>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import searchQueryState from '@/compositions/search/SearchQuery'
import placeholderImage from '@/assets/images/product-paceholder.png'
import tracking from '@/helpers/tracking'

export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    placement: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 1
    }
  },
  setup(props, context) {
    const {
      activeCategories,

      addCategory,
      removeCategory,
      removeAllCategories
    } = searchQueryState.searchQueryUse()
    const singleCategory = ref(props.model.isSingleFilterGroup
      ? props.model.items[0] : null)

    const isOpened = ref(props.model.isOpenedOnLoad)

    const total = computed(() => {
      const { items: uids } = props.model
      return activeCategories.value.filter(({ uid }) => uids.some((category) => category.uid === uid)).length
    })

    const toggleOpen = () => {
      isOpened.value = !isOpened.value
      if (isOpened.value) {
        const {
          placement,
          model: {
            name: filterCategory
          }
        } = props
        tracking.expandFilterMenu({
          filterCategory,
          placement
        })
      }
    }

    const checkActive = (uid) => activeCategories.value?.some((category) => category.uid === uid)

    const onChangeCategory = (category, e) => {
      e.preventDefault()
      const { name: filterName } = category
      const {
        placement,
        model: {
          name: filterCategory
        }
      } = props

      if (!checkActive(category.uid)) {
        tracking.selectFilter({
          filterName,
          placement,
          filterCategory
        })
        removeAllCategories()
        addCategory(category)
        context.emit('changeCategory')
      } else {
        tracking.removeFilter({
          filterName,
          placement
        })
        removeCategory(category)
      }
    }

    return {
      isOpened,
      total,
      placeholderImage,
      singleCategory,

      checkActive,
      toggleOpen,
      onChangeCategory
    }
  }
}
</script>
<style scoped>
  .filter-category {
    flex: 0 0 96px;
  }
  @media screen and (max-width: 400px) {
    flex: 0 0 85px;
  }
</style>
